import cn from "classnames";
import { useEffect, useRef, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import useDarkMode from "use-dark-mode";
import Tooltip from "../Tooltip";
import styles from "./Dropdown.module.sass";

const Dropdown = ({
  className,
  classDropdownHead,
  classDropdownLabel,
  value,
  setValue,
  options,
  isWhite,
  label,
  tooltip,
  small,
  upBody,
}) => {
  const [visible, setVisible] = useState(false);
  const darkMode = useDarkMode(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (visible && dropdownRef.current) {
      const parents = [];
      let parent = dropdownRef.current.parentNode;
      while (parent && parent !== document.body) {
        if (parent.nodeType === 1) {
          const style = window.getComputedStyle(parent);
          if (
            style.position !== 'static' ||
            style.transform !== 'none' ||
            style.filter !== 'none' ||
            style.backdropFilter !== 'none'
          ) {
            const oldZIndex = parent.style.getPropertyValue('z-index');
            const oldHasZIndex = parent.style.getPropertyPriority('z-index');
            parents.push({ el: parent, oldZIndex, oldHasZIndex });
            parent.style.setProperty('z-index', '99999', 'important');
          }
        }
        parent = parent.parentNode;
      }
      return () => {
        parents.forEach(({ el, oldZIndex, oldHasZIndex }) => {
          if (oldZIndex) {
            el.style.setProperty('z-index', oldZIndex, oldHasZIndex || '');
          } else {
            el.style.removeProperty('z-index');
          }
        });
      };
    }
  }, [visible]);

  const handleClick = (value) => {
    setValue(value);
    setVisible(false);
  };

  const labelValue = options ? options.find((op) => op?.value === value) : ''

  return (
    <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
      {label && (
        <div className={cn(styles.label, classDropdownLabel)}>
          {label} {tooltip && <Tooltip className={styles.tooltip} title={tooltip} icon="info" place="right" />}
        </div>
      )}
      <div
        ref={dropdownRef}
        className={cn(
          styles.dropdown,
          className,
          { [styles.small]: small },
          {
            [styles.active]: visible,
          }
        )}
      >
        <div style={isWhite && !darkMode.value ? {background: 'white'} : {}} className={cn(styles.head, classDropdownHead)} onClick={() => setVisible(!visible)}>
          <div className={styles.selection}>{labelValue ? labelValue.label : value}</div>
        </div>
        <div className={cn(styles.body, { [styles.bodyUp]: upBody })}>
          {options?.map((x, index) => (
            <div
              className={cn(styles.option, {
                [styles.selectioned]: x.value === value,
              })}
              onClick={() => handleClick(x.value, index)}
              key={index}
            >
              {x.label}
            </div>
          ))}
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export default Dropdown;
